import React, {useRef, useState} from 'react'
import {toast} from 'react-toastify'
import './LoadingButton.css'

interface LoadingButtonProps {
  onClick: () => Promise<void>
  children: React.ReactNode
  disabled?: boolean
}

const LoadingButton: React.FC<LoadingButtonProps> = ({onClick, children, disabled = false}) => {
  const [loading, setLoading] = useState(false)
  const busy = useRef(false)
  const handleClick = async () => {
    if (busy.current || disabled) return
    busy.current = true
    setLoading(true)
    try {
      await onClick()
    } catch {
      toast.error('İşlem tamamlanamadı. Lütfen tekrar deneyin.')
    } finally {
      busy.current = false
      setLoading(false)
    }
  }
  return (
    <button type='button' className='button education-loading-button' onClick={handleClick}
      disabled={disabled || loading} aria-busy={loading}>
      {loading && <span className='education-button-spinner' aria-hidden='true' />}
      {loading ? 'İşleniyor…' : children}
    </button>
  )
}
export default LoadingButton
